export type Image = {
  src: string;
  alt: string;
  width: number;
  // height: number;
};

const images: Image[] = [
  {
    src: "/imgs/storeImgDummies/store_img_dummy1.png",
    alt: "Image 1",
    width: 490,
    // height: 348,
  },
  {
    src: "/imgs/storeImgDummies/store_img_dummy2.png",
    alt: "Image 2",
    width: 490,
    // height: 348,
  },
  {
    src: "/imgs/storeImgDummies/store_img_dummy3.png",
    alt: "Image 3",
    width: 490,
    // height: 348,
  },
  {
    src: "/imgs/storeImgDummies/store_img_dummy4.png",
    alt: "Image 4",
    width: 490,
    // height: 348,
  },
  {
    src: "/imgs/storeImgDummies/store_img_dummy5.png",
    alt: "Image 5",
    width: 490,
    // height: 348,
  },
];

export default images;
